export default __webpack_public_path__ + "static/media/delete.a8f66609.svg";